import { render, staticRenderFns } from "./ErpDlsReturnsHuan.vue?vue&type=template&id=c52c39e8&scoped=true&"
import script from "./ErpDlsReturnsHuan.vue?vue&type=script&lang=js&"
export * from "./ErpDlsReturnsHuan.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsReturnsHuan.vue?vue&type=style&index=0&id=c52c39e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c39e8",
  null
  
)

export default component.exports